/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS0Icon20Regular = forwardRef('MediaAudioVolumeS0Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.102 2.247c.746-.64 1.898-.11 1.898.873v13.76c0 .983-1.152 1.513-1.898.873L4.722 14H2a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2.723l4.379-3.753ZM9.5 3.88 5.629 7.199a1.25 1.25 0 0 1-.814.301H2a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2.815c.298 0 .587.107.814.3L9.5 16.12V3.88Z" })));
});
